import { useMemo } from 'react'
import { usePositionsContextValue } from 'pages/Positions/Positions/context/PositionsProvider'
import { Positions } from 'pages/Positions/Positions/types'
import { ColumnDef } from '@tanstack/react-table'
import { IDColumn, DetailColumn, selectableColumns } from './columns'

export const useSelectedColumns = (): ColumnDef<Positions[number]>[] => {
  const {
    state: { selectedColumnsFilters },
  } = usePositionsContextValue()

  const columnsToDisplay = useMemo(() => {
    const filteredColumns = selectableColumns
      .filter((column) => selectedColumnsFilters.includes(column.id))
      .map((column) => column.columnDef)

    return [IDColumn, ...filteredColumns, DetailColumn]
  }, [selectedColumnsFilters])

  return columnsToDisplay
}
